import MultiSelectInput from 'components/forms/inputs/rhf-inputs/MultiSelectInput';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import InfoTooltip from 'components/InfoTooltip';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { ContactFormState } from './useContactForm';

/** Marketing: a person's mailing language and preferences, marketing areas and jurisdictions of interest. */
export const MarketingFields = ({ form }: { form: ContactFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const {
        classifiers,
        handleMailingPreferencesChange,
        isPreferredMailingLanguageRequired,
        mailingPreferenceOptions,
        marketingLanguageOptions,
    } = form;

    return (
        <>
            <SelectInput
                setValue={setValue}
                control={control}
                label="contacts.marketing.preferred-mailing-language"
                name="preferredMailingLanguageTypeCode"
                options={marketingLanguageOptions}
                getOptionLabel="label"
                getOptionIdentifier="value"
                placeholder="contacts.marketing.preferred-mailing-language"
                required={isPreferredMailingLanguageRequired}
            />
            <MultiSelectInput
                control={control}
                name="mailingPreferences"
                label="contacts.marketing.mailing-preferences"
                placeholder="contacts.marketing.mailing-preferences"
                options={mailingPreferenceOptions}
                tooltip={<InfoTooltip text="contacts.marketing.tooltips.mailing-preferences" />}
                setValue={setValue}
                onChange={handleMailingPreferencesChange}
                getOptionLabel="label"
                getOptionIdentifier="value"
                sortDirection="asc"
            />
            <MultiSelectInput
                control={control}
                name="marketingAreaTypes"
                label="contacts.marketing.preferred-marketing-areas"
                placeholder="contacts.marketing.preferred-marketing-areas"
                tooltip={<InfoTooltip text="contacts.marketing.tooltips.preferred-marketing-areas" />}
                options={getValidOptionsFromClassifier<string, string>(classifiers['MARKETING_AREA_TYPE']) ?? []}
                setValue={setValue}
                getOptionLabel="label"
                getOptionIdentifier="value"
                sortDirection="asc"
                hasSelectAllOption
            />
            <MultiSelectInput
                control={control}
                name="countries"
                label="contacts.marketing.jurisdictions-of-interest"
                placeholder="contacts.marketing.jurisdictions-of-interest"
                tooltip={<InfoTooltip text="contacts.marketing.tooltips.jurisdictions-of-interest" />}
                options={getValidOptionsFromClassifier<string, string>(classifiers['COUNTRY']) ?? []}
                setValue={setValue}
                getOptionLabel="label"
                getOptionIdentifier="value"
                sortDirection="asc"
            />
        </>
    );
};
